import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { errorToast, successToast } from "../../../utils/toasts";
import { invalidateTagAffectedQueries } from "./invalidateTagAffectedQueries";

export const useDeleteTagMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(["tags"]);
  return useMutation({
    mutationFn: async (id: number) => await apiClient.deleteTag(undefined, { params: { id } }),
    onSuccess: () => {
      successToast({ message: t(($) => $.tags["Tag deleted successfully"]) });
      invalidateTagAffectedQueries(queryClient);
    },
    onError: (error) => {
      errorToast({ message: t(($) => $.tags["Failed to delete tag"]), error });
    },
  });
};
